export const chartEventsAsyncModule = {
  importFn: () => import(/* webpackChunkName: "chart-events" */ './module-entry'),
  cacheKey: 'chart-events',
}
